import { createSlice } from "@reduxjs/toolkit";

const previousCreationSlice = createSlice({
  name: "previousCreation",
  initialState: null,
  reducers: {
    setPreviousCreation: (state, action) => action.payload,
    clearPreviousCreation: () => null,
  },
});

export const { setPreviousCreation, clearPreviousCreation } =
  previousCreationSlice.actions;

export default previousCreationSlice.reducer;